// extracted by mini-css-extract-plugin
export default {"wrapper":"Ar-z","response":"Br-z","error":"Cr-z","disabled":"Dr-z","buttons":"Er-z","feedbackQuestionSection":"Fr-z","yesNoWrapper":"Gr-z"};